module.exports = "/images/vendor/flag-icon-css/flags/1x1/pg.svg?0b07d41894441f5e68d862c5156f32cf";